module.exports = __webpack_public_path__ + "barcelona-a4a5678c6c2ea8b3addeede71efd8145.bundle.jpg";